import axios from '@/http/axios/index.js'


export default {
    getList(payload) {
        return axios.get('warehouse/clients/list', { params: payload })
    },
    updateGracePeriod(payload) {
        return axios.post('warehouse/grace_period/update',payload )
    }
}